// Display helpers of the Individual Activity views. Dates are stored in UTC
// and shown in the platform's configured time zone (Activity History setting)
// so every Family member reads the same day boundaries.
import { elakayIntlLocale } from "../../../pageInside/dataElakay";

const safeZone = (tz) => {
  if (!tz) return undefined;
  try { new Intl.DateTimeFormat("en-US", { timeZone: tz }).format(new Date()); return tz; } catch { return undefined; }
};

export const formatInZone = (value, tz, { withDate = true, withSeconds = false } = {}) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(elakayIntlLocale(), {
    ...(withDate ? { year: "numeric", month: "short", day: "numeric" } : {}),
    hour: "numeric", minute: "2-digit", ...(withSeconds ? { second: "2-digit" } : {}),
    timeZone: safeZone(tz),
  });
};

export const formatTime = (value, tz) => formatInZone(value, tz, { withDate: false });

export const formatDayTitle = (day) => {
  const d = new Date(`${day}T12:00:00Z`);
  return Number.isNaN(d.getTime()) ? day : d.toLocaleDateString(elakayIntlLocale(), { weekday: "long", year: "numeric", month: "long", day: "numeric", timeZone: "UTC" });
};

// "v_3f9a1c2b…" -- enough to tell records apart; the full key is in the title.
export const shortId = (vk) => (vk ? `${String(vk).slice(0, 10)}…` : "—");

export const durationLabel = (from, to) => {
  if (!from || !to) return "";
  const ms = new Date(to) - new Date(from);
  if (!(ms >= 0)) return "";
  const m = Math.round(ms / 60000);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  return `${h} h ${String(m % 60).padStart(2, "0")}`;
};
